export default __webpack_public_path__ + "static/g402-ce2bc72849ef70d212d279b35d1136e7.jpg";